export default __webpack_public_path__ + "static/media/hipaa-logo.253fbc86.png";